import React from "react";
import "./Group20.css";

function Group20() {
  return (
    <div className="group-20">
      <div className="ellipse-6-2"></div>
      <div className="ellipse-1"></div>
      <div className="ellipse-1"></div>
      <div className="ellipse-1"></div>
    </div>
  );
}

export default Group20;
